<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>{{translate(locale.editQuotation)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-70">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.quotationInformation)}}</h5>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100 text-right">
									<span class="late">{{translate(locale.required)}}</span>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<form-input v-model="tender.name" :label="locale.quotationName"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="tender.tender_category_id" :list="tender_category_list" :label="locale.quotationCategory"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="tender.tender_sub_category_id" :list="tender_sub_category_filtered_list" :label="locale.quotationSubCategory"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-select v-model="tender.location_province_id" :list="province_list" :label="locale.quotationLocation"/>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-50">
									<form-datetime v-model="tender.deadline_date" :label="locale.quotationDeadline" />
								</div>
							
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<Editor style="height: 500px;width: 100%;border-radius: 5px;"
										v-model="tender.content"
										api-key="ldywwz30g9zhdo7kgwt8jjimrbc7ypqozvkd0ur7vs8eg7uk"
										:init="editorConfig"/>
								</div>
								
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-30">
							<div class="md-layout">
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h5>{{translate(locale.quotationAttachment)}}</h5>
									<input type="file" ref="attachment" accept="" @change="handleAttachmentFile($event)" style="display: none"/>
								</div>
								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="attachment in tender.attachment">
									<div  class="attachment-preview">
										<div style="width: 100%">
											<a :href="config.cdn + 'attachments/' + attachment.file_hash" target="_blank">{{attachment.name}}</a>
										</div>
										<i style="color: #f44336 !important; text-align: center; cursor: pointer;" class="material-icons" @click="remove(attachment.file_hash)">delete</i>
										
									</div>
								</div>

								<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-if="tender.attachment.length < 10">
									<div  class="attachment-upload" style="cursor:pointer" @click="$refs.attachment.click()">
										<loading v-if="attachment_uploading"/>
										<div v-else style="display: flex; justify-content: center; justify-items: center;">
											<i style="color: #999; text-align: center;" class="material-icons">attachment</i>
											<span style="color: #999; text-align: center;margin-left: 5px">{{translate(locale.upload)}}</span>
										</div>
									</div>
								</div>
							</div>	
						</div>
						<div class="md-layout-item md-size-100 text-right">
							<span v-for="e in errors" style="color: red">* {{translate(e)}}<br></span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="updateTender()">{{translate(locale.updateQuotation)}}</md-button>
						</div>
					</div>
					
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>
	import Editor from '@tinymce/tinymce-vue';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Editor },
		created() {
			this.getSettings();
		},

		data() {
			return {
				loaded: false,
				uploading: false,
				attachment_uploading: false,
				tender: {
					name: "",
					content: "",
					location_province_id: "",
					tender_category_id: "",
					tender_sub_category_id: "",
					deadline_date: "",
					deadline_timestamp: "",
					status: "",
					attachment: []
				},
				province_list: [],
				tender_category_list: [],
				tender_sub_category_list: [],
				tender_sub_category_filtered_list: [],
				editorConfig: {
					height: 500,
					menubar: false,
					plugins: 'lists link image table code help wordcount',
					toolbar: 'undo redo | fontfamily fontsize | formatselect bold italic forecolor backcolor | image table | lineheight alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat| link code | help',
					font_family_formats: 'Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; Moul=Moul; Siemreap=Siemreap; Hanuman=Hanuman;',
					automatic_uploads: true,
					images_upload_handler: this.handleEditorFile,
				},
				errors: []
			}
		},
		watch: {
			'tender.tender_category_id' : function(val) {
				this.tender_sub_category_filtered_list = [];
				this.tender.tender_sub_category = "";
				this.tender.tender_sub_category_id = "";
				for(let i = 0; i< this.tender_sub_category_list.length; i++) {
					if(this.tender_sub_category_list[i].tender_category_id == val) this.tender_sub_category_filtered_list.push(this.tender_sub_category_list[i]);
				}
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/profile/setting/tender").then(data => {

					this.province_list = this.config.clearList(data.body.data.province, this.$store.state.l.lang);
					this.tender_category_list = this.config.clearList(data.body.data.tender_category, this.$store.state.l.lang);
					this.tender_sub_category_list = this.config.clearList(data.body.data.tender_sub_category, this.$store.state.l.lang);

					this.$http.get(this.config.api + "/profile/tender/get/" + this.$route.params.hash).then(data => {

						let tender = data.body.data.tender;
						let attachment = data.body.data.attachment;

						this.tender.name = tender.name;
						this.tender.content = tender.content;
						this.tender.tender_category_id = tender.tender_category_id;
						this.tender.location_province_id = tender.location_province_id;
						this.tender.deadline_date = (new Date(tender.deadline_date * 1000)).toISOString();

						for(let i =0; i< attachment.length; i++) {
							this.tender.attachment.push({name: attachment[i].name, file_hash: attachment[i].url});
						}
						this.loaded = true;

						setTimeout(() => {
							this.tender.tender_sub_category_id =tender.tender_sub_category_id;
						}, 200);

					})
				})
			},
			updateTender(draft = false) {

				if(draft) this.tender.status = 2;
				else this.tender.status = 1;

				this.tender.deadline_timestamp = (new Date(this.tender.deadline_date)).getTime();

				if(!this.checkValidation()) {
					this.$notification.notify({message: "Please fill in all required information.||សូមបំពេញព័ត៌មានឱ្យបានគ្រប់គ្រាន់។", icon: 'error', type: 'danger'});
					return;
				}

				this.$http.post(this.config.api + "/profile/tender/update", {
					hash: this.$route.params.hash,
					tender: this.tender
				}).then(res => {
					if(res.body.status == 'success') {
						this.$notification.notify({
							message: "You have updated your request for quotation/bidding successfully.",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/quotation_and_bidding");
					}
				})
			},

			handleEditorFile(blobInfo, success, failure) {

				const formData = new FormData();
				formData.append('file', blobInfo.blob(), blobInfo.filename());

				this.$http.post(this.config.api + "/profile/upload/image_content", formData).then(res => {
					if (res.body.status == 'success') {
						success(this.config.cdn + res.body.data.image_hash);
					} else {
						failure("Error uploading image.");
					}
				})
			},
			handleAttachmentFile(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.attachment.files[0]);
				this.attachment_uploading = true;
				this.$http.post(this.config.api + "/profile/upload/attachment", formData).then(res => {
					this.attachment_uploading = false;
					if (res.body.status == 'success') {
						this.tender.attachment.push(res.body.data);
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if(String(this.tender.name).length < 3) this.errors.push("Title is empty.");
				if(String(this.tender.content).length < 3) this.errors.push("Content is empty.");
				if(String(this.tender.tender_category_id).length <= 0) this.errors.push("Quotation/Bidding Category is empty.");
				if(String(this.tender.tender_sub_category_id).length <= 0) this.errors.push("Quotation/Bidding Sub-Category is empty.");
				if(String(this.tender.location_province_id).length <= 0) this.errors.push("Quotation/Bidding Location is empty.");
				if(String(this.tender.deadline_timestamp).length <= 0 || parseInt(this.tender.deadline_timestamp) == NaN) this.errors.push("Quotation/Bidding Deadline is invalid.");

				
				if(this.errors.length == 0) return true;
				else return false;
			},
			remove(hash){
				const index = this.tender.attachment.findIndex((obj) => obj.file_hash == hash);
				if (index > -1) this.tender.attachment.splice(index, 1);
			},
		}
	}
</script>
<style scoped>
	.cover-image {
		border: 1px dashed #ccc; 
		min-height: 120px;
		/* margin-bottom: 8px;  */
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center; 
		cursor:pointer
	}
	.gallery-image {
		border: 1px dashed #ccc; 
		min-height: 120px; 
		margin-bottom: 8px;
		padding: 20px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.attachment-preview {
		border: 1px dashed #ccc; 
		margin-bottom: 8px; 
		padding: 10px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: left; 
		align-items: center
	}
	.attachment-upload {
		border: 1px dashed #ccc; 
		margin-bottom: 8px; 
		padding: 8px; 
		border-radius: 6px; 
		display: flex; 
		justify-content: center; 
		align-items: center
	}
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Quotation/Edit.vue